import Vue from "vue";
import VueRouter, { RouterView } from "vue-router";
import Main from "../pages/Home/index.vue";
import Search from "../pages/Home/search.vue";
import Searchlist from "../pages/Home/searchlist.vue";
import Searchlistdetail from "../pages/Home/searchlistdetail.vue";
import searchResult from '@/pages/Home/searchResult.vue'
import header from '@/pages/Home/header.vue'
import legislationService from "@/pages/Home/legislationService.vue";
import jiliangService from "@/pages/Home/jiliangService.vue";
import jiliangServiceDetail from "@/pages/Home/jiliangServiceDetail.vue";
import jianyanServiceDetail from "@/pages/Home/jianyanServiceDetail.vue";
import jiliangnengli from "@/pages/Home/jiliangnengli.vue";
import chanyejiliangzhongxinDetail from "@/pages/Home/chanyejiliangzhongxinDetail.vue";
import jianyanjianceService from "@/pages/Home/jianyanjianceService.vue";
import jiancenengli from "@/pages/Home/jiancenengli.vue";
import jianyanService from "@/pages/Home/jianyanService.vue";
import jiancenengliDetail from "@/pages/Home/jiancenengliDetail.vue";
import shareShiyanshi from "@/pages/Home/shareShiyanshi.vue";
import shiyanshiDetail from "@/pages/Home/shiyanshiDetail.vue";
import biaozhunchaxun from "@/pages/Home/biaozhunchaxun.vue";
import biaozhunService from "@/pages/Home/biaozhunService.vue";
import renzhengjianyanLegislation from "@/pages/Home/renzhengjianyanLegislation.vue";
import talentsTrain from "@/pages/Home/talentsTrain.vue";
import biaozhunhuaLegislation from "@/pages/Home/biaozhunhuaLegislation.vue";
import imgDetail from "@/pages/Home/imgDetail.vue";
import qualityLegislation from "@/pages/Home/qualityLegislation.vue";
import qualityBrand from "@/pages/Home/qualityBrand.vue";
import brandBuild from "@/pages/Home/brandBuild.vue";

import hometwo from "@/pages/Home/hometwo.vue";
import ScrollItem from "@/pages/Home/scrollItem.vue";

import zhuanyequn from "@/pages/zhuanyequn/index.vue"
import zhuanyequnHeader from "@/pages/zhuanyequn/zhuanyequnHeader.vue";
import zhuanyequnScrollItem from "@/pages/zhuanyequn/zhuanyequnScrollItem.vue"

import lianheti from '@/pages/lianheti/index.vue'
import lianhetiHeader from '@/pages/lianheti/lianhetiHeader.vue'
import lianhetiScrollItem from '@/pages/lianheti/lianhetiScrollItem.vue'

import gongtongti from "@/pages/gongtongti/index.vue"
import gongtongtiHeader from '@/pages/gongtongti/header.vue'
import gongtongtiScrollItem from '@/pages/gongtongti/scrollItem.vue'

import chengguozhanshi from '@/pages/chengguozhanshi/index.vue'
import chengguozhanshiHeader from '@/pages/chengguozhanshi/header.vue'
import chengguozhanshiScrollItem from '@/pages/chengguozhanshi/scrollItem.vue'

import cjContent from "@/pages/Home/cjContent.vue";
import cjContentDetail from "@/pages/Home/cjContentDetail.vue";
import chujuMain from "@/pages/Home/chujuMain.vue";
import buxiugangMain from "@/pages/Home/buxiugangMain.vue";
import taociMain from "@/pages/Home/taociMain.vue";
import chujuSub from "@/pages/Home/chujuSub.vue";
import jiajuMain from "@/pages/Home/jiajuMain.vue";

import NQR from "@/pages/Home/NQR.vue";
import NQI from "@/pages/Home/NQI.vue";
import NQIDetail from "@/pages/Home/NQIDetail.vue";
import serviceOrganization from "@/pages/Home/serviceOrganization.vue";

// const hometwo2 = () => import("../pages/Home/hometwo.vue")
Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "Home",
            component: Main,
            children: [],
        },
        {
            path: "/home",
            name: "Home",
            component: Main,
            children: [],
        },
        
        {
            path: "/search",
            name: "Search",
            component: Search,
            children: [],
        },
        {
            path: "/searchlist",
            name: "Searchlist",
            component: Searchlist,
            children: [],
        },
        {
            path: "/searchlistdetail",
            name: "Searchlistdetail",
            component: Searchlistdetail,
            children: [],
        },

        {
            path: "/hometwo",
            name: "hometwo",
            component: hometwo,
            children: [],
        },
        {
            path: "/searchResult",
            name: "searchResult",
            component: searchResult,
            children: [],
        },
        {
            path: "/header",
            name: "header",
            component: header,
            children: [],
        },
        {
            path: "/legislationService",
            name: "legislationService",
            component: legislationService,
            children: [],
        },
        {
            path: "/jiliangService",
            name: "jiliangService",
            component: jiliangService,
            children: [],
        },
        {
            path: "/jiliangServiceDetail",
            name: "jiliangServiceDetail",
            component: jiliangServiceDetail,
            children: [],
        },
        {
            path: "/jianyanServiceDetail",
            name: "jianyanServiceDetail",
            component: jianyanServiceDetail,
            children: [],
        },
        {
            path: "/jiliangnengli",
            name: "jiliangnengli",
            component: jiliangnengli,
            children: [],
        },
        {
            path: '/chanyejiliangzhongxinDetail',
            name: 'chanyejiliangzhongxinDetail',
            component: chanyejiliangzhongxinDetail,
            children: []
        },
        {
            path: '/jianyanjianceService',
            name: 'jianyanjianceService',
            component: jianyanjianceService,
            children: []
        },
        {
            path: '/jiancenengli',
            name: 'jiancenengli',
            component: jiancenengli,
            children: []
        },
        {
            path: '/jianyanService',
            name: 'jianyanService',
            component: jianyanService,
            children: []
        },
        {
            path: '/jiancenengliDetail',
            name: 'jiancenengliDetail',
            component: jiancenengliDetail,
            children: []
        },
        {
            path: '/shareShiyanshi',
            name: 'shareShiyanshi',
            component: shareShiyanshi,
            children: []
        },
        {
            path: '/shiyanshiDetail',
            name: 'shiyanshiDetail',
            component: shiyanshiDetail,
            children: []
        },
        {
            path: '/biaozhunchaxun',
            name: 'biaozhunchaxun',
            component: biaozhunchaxun,
            children: []
        },
        {
            path: '/biaozhunService',
            name: 'biaozhunService',
            component: biaozhunService,
            children: []
        },
        {
            path: '/renzhengjianyanLegislation',
            name: 'renzhengjianyanLegislation',
            component: renzhengjianyanLegislation,
            children: []
        },
        {
            path: '/talentsTrain',
            name: 'talentsTrain',
            component: talentsTrain,
            children: []
        },
        {
            path: '/biaozhunhuaLegislation',
            name: 'biaozhunhuaLegislation',
            component: biaozhunhuaLegislation,
            children: []
        },
        {
            path: '/imgDetail',
            name: 'imgDetail',
            component: imgDetail,
            children: []
        },
        {
            path: '/qualityLegislation',
            name: 'qualityLegislation',
            component: qualityLegislation,
            children: []
        },
        {
            path: '/cjContent',
            name: 'cjContent',
            component: cjContent,
            children: []
        },
        {
            path: '/cjContentDetail',
            name: 'cjContentDetail',
            component: cjContentDetail,
            children: []
        },
        {
            path: '/kitchenwareMain',
            name: 'chujuMain',
            component: chujuMain,
            children: []
        },
        {
            path: '/stainlessSteelMain',
            name: 'buxiugangMain',
            component: buxiugangMain,
            children: []
        },
        {
            path: '/ceramicsMain',
            name: 'taociMain',
            component: taociMain,
            children: []
        },
        {
            path: '/furnitureMain',
            name: 'jiajuMain',
            component: jiajuMain,
            children: []
        },
        {
            path: '/chujuSub',
            name: 'chujuSub',
            component: chujuSub,
            children: []
        },
        {
            path: '/NQR',
            name: 'NQR',
            component: NQR,
            children: []
        },
        {
            path: '/NQI',
            name: 'NQI',
            component: NQI,
            children: []
        },
        {
            path: '/NQIDetail',
            name: 'NQIDetail',
            component: NQIDetail,
            children: []
        },
        {
            path: '/serviceOrganization',
            name: 'serviceOrganization',
            component: serviceOrganization,
            children: []
        },
        {
            path: '/qualityBrand',
            name: 'qualityBrand',
            component: qualityBrand,
            children: []
        },
        {
            path: '/brandBuild',
            name: 'brandBuild',
            component: brandBuild,
            children: []
        },
        {
            path: '/chengguozhanshi',
            component: () => import('../pages/chengguozhanshi/index.vue'),
            children: [
                {
                    path: '/',
                    component: chengguozhanshi
                },
                {
                    path: '/header',
                    name: 'chengguozhanshiHeader',
                    component: chengguozhanshiHeader,
                    children: []
                },
                {
                    path: '/scrollItem',
                    name: 'chengguozhanshiScrollItem',
                    component: chengguozhanshiScrollItem,
                    children: []
                }
            ]
        },
        {
            path: '/zhuanyequn',
            component: () => import('../pages/zhuanyequn/index.vue'),
            children: [
                {
                    path: '/',
                    component: zhuanyequn
                },
                {
                    path: '/zhuanyequnHeader',
                    name: 'zhuanyequnHeader',
                    component: zhuanyequnHeader,
                    children: []
                },
                {
                    path: '/zhuanyequnScrollItem',
                    name: 'zhuanyequnScrollItem',
                    component: zhuanyequnScrollItem,
                    children: []
                }
            ]
        },
        {
            path: '/lianheti',
            component: () => import('../pages/lianheti/index.vue'),
            children: [
                {
                    path: '/',
                    component: lianheti
                },
                {
                    path: '/lianhetiHeader',
                    name: 'lianhetiHeader',
                    component: lianhetiHeader,
                    children: []
                },
                {
                    path: '/scrollItem',
                    name: 'lianhetiScrollItem',
                    component: lianhetiScrollItem,
                    children: []
                }
            ]
        },
        {
            path: '/gongtongti',
            component: () => import('../pages/gongtongti/index.vue'),
            children: [
                {
                    path: '/',
                    component: gongtongti
                },
                {
                    path: '/header',
                    name: 'gongtongtiHeader',
                    component: gongtongtiHeader,
                    children: []
                },
                {
                    path: '/scrollItem',
                    name: 'gongtongtiScrollItem',
                    component: gongtongtiScrollItem,
                    children: []
                }
            ]
        }
    ],
});

const originnalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    // console.log(location);   // 路由的name和path
    return originnalPush.call(this, location).catch((err) => err);
};
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});
//跳转后 回到最上方
router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
    next()
});
const routerPush = router.push;


router.push = path => {
  // 判断下当前路由是否就是要跳转的路由
  if (router.currentRoute.fullPath.includes(path)) return;
  return routerPush.call(router, path);
}
export default router;
